module.exports = __webpack_public_path__ + "img/link.c82c9d56.svg";